export type GetProjectTicketsResponse = {
  interfaceDefinitions: InterfaceDefinitionDetail[];
  componentProjects: ComponentProjectDetail[];
};

export type InterfaceDefinitionDetail = {
  tag: string;
  stgDplymntPlnDate: string;
  prdDplymntPlnDate: string;
  total: number;
  stsDsgnDesigning: number;
  stsDsgnReviewing: number;
  stsStgDplymntPlanning: number;
  stsStgDplymntPlanningBlocked: number;
  stsStgDplymntAwaitingApproval: number;
  stsStgDplymntPlanned: number;
  stsPrdDplymntPlanning: number;
  stsPrdDplymntPlanningBlocked: number;
  stsPrdDplymntAwaitingApproval: number;
  stsPrdDplymntPlanned: number;
  stsCompleted: number;
};

export type ComponentProjectDetail = {
  pjtId: string;
  pjtName: string;
  stgSchedDplymntDate: string;
  prdSchedDplymntDate: string;
  dipByRgn: string;
  cpntId: string;
  cpntPjtTypeCd: string;
  cpntPjtTypeName: string;
  inOutTypeCd: string;
  inOutTypeName: string;
  prtcolTypeCd: string;
  prtcolTypeName: string;
  reqTskSlctdFlg: string;
  stgIfdDplymntPsblFlg: string;
  prdIfdDplymntPsblFlg: string;
  completedFlg: string;
};
